import React from 'react';
import { Button } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

const confirmDeletePresentation = (intl, id, deletePresentationWithoutPptMutation, delHeader) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className='confirm-delete-modal'>
          <h3>{intl.formatMessage({id: delHeader})}</h3>
            <Button
          variant="primary"
            onClick={() => {
              console.log(deletePresentationWithoutPptMutation({ event_id: id }))
              onClose();
            }}
          >
            {intl.formatMessage({id: 'yes'})}
          </Button>
          <Button variant="default" onClick={onClose}>{intl.formatMessage({id: 'no'})}</Button>
        </div>
      );
    }
  });
};

export default confirmDeletePresentation;